export default "__VITE_ASSET__1789dfe6__"